/**
 * PostHog analytics events for product analytics.
 * Use with posthog from usePostHog() - events are no-op when posthog is undefined.
 */

/** Centralized environment for analytics: local, qa, or prod */
export function getAnalyticsEnvironment(): string {
  const env = import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE ?? 'development';
  return env === 'development' ? 'local' : env;
}

interface PostHogClient {
  capture: (event: string, properties?: Record<string, unknown>) => void;
}

export function captureBillUploaded(
  posthog: PostHogClient | undefined,
  properties: {
    fileCount: number;
    totalUploaded: number;
    totalDuplicates: number;
    totalFailed: number;
    entityId: string;
  },
) {
  posthog?.capture('bill_uploaded', properties);
}

export function captureBillSaved(
  posthog: PostHogClient | undefined,
  properties: {
    billId: string;
    savedHeader: boolean;
    savedClassifications: boolean;
  },
) {
  posthog?.capture('bill_saved', properties);
}

export function captureBillSentForApproval(
  posthog: PostHogClient | undefined,
  properties: {
    billId: string;
    amount?: number;
    currency?: string;
  },
) {
  posthog?.capture('bill_sent_for_approval', properties);
}
